import { render } from "./SectionTitle.vue?vue&type=template&id=f6d18ca4&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=f6d18ca4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d18ca4"]])

export default __exports__